import { Loader2 } from 'lucide-react';
import React from 'react';
import { Button } from '../button';
import { cn } from '@/lib/utils';

const CustomButton = React.forwardRef(
	(
		{
			loading,
			selected,
			className,
			disabled,
			variant, // Add variant prop
			size,
			asChild,
			...props
		},
		ref
	) => {
		// Determine the variant based on the passed props
		const buttonVariant =
			variant !== undefined ? variant : selected ? 'default' : 'ghost';

		return (
			<Button
				ref={ref}
				variant={buttonVariant} // Use the determined variant
				className={cn(disabled && 'opacity-30', className)}
				disabled={disabled}
				size={size}
				asChild={asChild}
				{...props}
			>
				{loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
				{props.children}
			</Button>
		);
	}
);

CustomButton.displayName = 'CustomButton';

export { CustomButton };
